export const createGetUserInfoRequest = () =>{
    return {
        url: "/user_infos",
        method: "GET"
    };
}

export const createSaveUserInfoRequest = (source_of_discovery, linked_in_profile_url, user_type, onboarding_completed = true) =>{
    return {
        url: "/user_infos",
        method: "POST",
        data: {
            source_of_discovery: source_of_discovery,
            onboarding_completed,
            linked_in_profile_url,
            user_type: user_type,
        }
    };
}

export const createOrgOnboardingRequest = (source_of_discovery, linked_in_profile_url, team_size, problems_to_solve) => {
    return {
        url: "/user_infos",
        method: "POST",
        data: {
            source_of_discovery,
            linked_in_profile_url,
            team_size,
            problems_to_solve,
            onboarding_completed: true,
        }
    };
}

export const createUpdateUserInfoRequest = (id, source_of_discovery, linked_in_profile_url, user_type, onboarding_completed = true) =>{
    return {
        url: "/user_infos",
        method: "PUT",
        data: {
            id: id,
            source_of_discovery: source_of_discovery,
            onboarding_completed,
            linked_in_profile_url,
            user_type: user_type,
        }
    };
}